export const removeDiacritics = (str) => {
    return str.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
  };
export const fileNameEdit = () => {
const currentActiveItem = document.querySelector('.ant-menu-item-selected').textContent;
let fileTitle = '';
if (currentActiveItem.trim().split(/\s+/).length > 1) {
    fileTitle += `${removeDiacritics(currentActiveItem).replace(/\s+/g, '_').toLowerCase()}`;
} else {
    fileTitle += `${removeDiacritics(currentActiveItem).toLowerCase()}`;
}
const currentDate = new Date();
const formattedDate = `${currentDate.getDate()}_${(currentDate.getMonth() + 1)
.toString()
.padStart(2, '0')}_${currentDate.getFullYear().toString().padStart(2, '0')}`;
return `${fileTitle}_${formattedDate}.xlsx`;
};